export default "__VITE_ASSET__8849514f__"